import React, {useEffect} from "react";
import {hasResponseError, loadSettings} from "../../api/requests";
import {Settings} from "../../models/models";
import {
    getPreferredACPaymentMethod,
    getPreferredVDSPaymentMethod,
    getPreferredVRIPaymentMethod
} from "../../helpers/helpers";

const SubscriptionsContainerDataRefreshManager = ({
                                                      shouldRefresh,
                                                      setSettings,
                                                      setLoading,
                                                      setAppCenterData,
                                                      setVriData,
                                                      setVdsData,
                                                      setPreferredACPaymentMethod,
                                                      setPreferredVDSPaymentMethod,
                                                      setPreferredVRIPaymentMethod
                                                  }) => {
    useEffect(() => {
        setLoading(true);

        let isSubscribed = true;
        isSubscribed && loadSettings((response) => {
            if (hasResponseError(response)) {
                setLoading(false);
                return;
            }

            const allPaymentMethods = response.data.ac.allPaymentMethods;

            setSettings(new Settings(response));
            setAppCenterData(response.data.ac);
            setVriData(response.data.vri);
            setVdsData(response.data.vds);
            setPreferredACPaymentMethod(getPreferredACPaymentMethod(allPaymentMethods));
            setPreferredVDSPaymentMethod(getPreferredVDSPaymentMethod(allPaymentMethods));
            setPreferredVRIPaymentMethod(getPreferredVRIPaymentMethod(allPaymentMethods));
            setLoading(false);
        });
        return () => (isSubscribed = false);
    }, [shouldRefresh]);
    return <></>
}

export default SubscriptionsContainerDataRefreshManager;